import { DiscoveryStatusByProduct } from '@interfaces/discoveryStatus';

export type DiscoveryFeature =
  | 'integrations'
  | 'remarketing'
  | 'downsell'
  | 'upsell'
  | 'scheduleMessages'
  | 'affiliation'
  | 'referral'
  | 'coupon'
  | 'bump';

/**
 * A janela padrão, e a que vale para os convites de ADOÇÃO: a feature não vai a lugar
 * nenhum, e insistir toda semana só ensina o criador a ignorar o X.
 */
export const DISCOVERY_CARD_DISMISSAL_DAYS = 30;

/**
 * Quantos dias o card fica calado depois de dispensado, por feature.
 *
 * A mensagem agendada é de outra natureza: não é convite de adoção, é lembrete de
 * CADÊNCIA, e a cadência que ela cobra é de 2 envios por semana. Trinta dias
 * transformariam o lembrete em mensal, que é o mesmo que não lembrar.
 */
const DIAS_DE_DISPENSA_POR_FEATURE: Record<DiscoveryFeature, number> = {
  integrations: DISCOVERY_CARD_DISMISSAL_DAYS,
  remarketing: DISCOVERY_CARD_DISMISSAL_DAYS,
  downsell: DISCOVERY_CARD_DISMISSAL_DAYS,
  upsell: DISCOVERY_CARD_DISMISSAL_DAYS,
  scheduleMessages: 7,
  affiliation: DISCOVERY_CARD_DISMISSAL_DAYS,
  referral: DISCOVERY_CARD_DISMISSAL_DAYS,
  coupon: DISCOVERY_CARD_DISMISSAL_DAYS,
  bump: DISCOVERY_CARD_DISMISSAL_DAYS,
};

export const resolveDismissalDays = (feature: DiscoveryFeature): number =>
  DIAS_DE_DISPENSA_POR_FEATURE[feature] ?? DISCOVERY_CARD_DISMISSAL_DAYS;

const DIA_EM_MS = 24 * 60 * 60 * 1000;

type Args = {
  feature: DiscoveryFeature;
  statusByProduct: DiscoveryStatusByProduct;
  selectedIds: number[];
  hasSales: boolean;
  dismissedAt: number | null;
  now: number;
};

/**
 * O card só aparece quando nenhuma das comunidades do recorte tem a feature.
 * Se alguma tem, o relatório já traz dado real e o card viraria ruído por
 * cima de informação. Status faltando é tratado como "não sei ainda", e na
 * dúvida não mostramos nada.
 */
export const shouldShowDiscoveryCard = (args: Args): boolean => {
  if (!args.hasSales) return false;
  if (args.selectedIds.length === 0) return false;

  const dispensadoHa = args.dismissedAt ? args.now - args.dismissedAt : null;
  if (
    dispensadoHa !== null &&
    dispensadoHa < resolveDismissalDays(args.feature) * DIA_EM_MS
  ) {
    return false;
  }

  return args.selectedIds.every((id) => {
    const status = args.statusByProduct[id];

    return status ? status[args.feature] === false : false;
  });
};
